import { ReactElement } from 'react';

const NoMatch = (): ReactElement => {
  return <div className="no-match-page">NOT FOUND!</div>;
};

export default NoMatch;
